type CurrencyParts = {
  symbol?: string | null
  code?: string | null
  name?: string | null
  fallback?: string | number | null
}

const KNOWN_CURRENCY_CODES_BY_NAME: Record<string, string> = {
  'united arab emirates dirham': 'AED',
  'uae dirham': 'AED',
  dirham: 'AED',
}

const normalizePart = (value: unknown) => String(value ?? '').trim()

const isShortCurrencyCode = (value: string) => /^[A-Z]{3}$/.test(value)

const resolveCurrencyCode = (...values: unknown[]) => {
  for (const value of values) {
    const normalized = normalizePart(value)
    if (!normalized) {
      continue
    }

    const upper = normalized.toUpperCase()
    if (isShortCurrencyCode(upper)) {
      return upper
    }

    const mapped = KNOWN_CURRENCY_CODES_BY_NAME[normalized.toLowerCase()]
    if (mapped) {
      return mapped
    }
  }

  return ''
}

const resolveCurrencySymbol = (...values: unknown[]) => {
  for (const value of values) {
    const normalized = normalizePart(value)
    if (normalized && normalized.length <= 8) {
      return normalized
    }
  }

  return ''
}

export function formatShortCurrencyLabel({ symbol, code, name, fallback }: CurrencyParts) {
  const shortSymbol = resolveCurrencySymbol(symbol)
  const shortCode = resolveCurrencyCode(code, symbol, name, fallback)

  if (shortSymbol && shortCode) {
    return `${shortSymbol} ${shortCode}`
  }

  return shortCode || shortSymbol || normalizePart(fallback) || '-'
}

export function getCurrencySymbol(symbol?: string | null, code?: string | null) {
  return resolveCurrencySymbol(symbol) || resolveCurrencyCode(code) || '$'
}
